import type { FC, MouseEventHandler } from 'react';
import icons from '@icons';
import { Picture } from '@ui';
import type { IconType } from '@root/src/types';

const {
  chevronLeft: {
    white: chevronLeftWhite,
    lightGrey: chevronLeftLg,
    red: chevronLeftRed,
    darkGrey: chevronLeftDG
  },
  chevronRight: {
    white: chevronRightWhite,
    lightGrey: chevronRightLg,
    red: chevronRightRed,
    darkGrey: chevronRightDG
  }
} = icons.Outline;

interface ArrowProps {
  onClick?: MouseEventHandler;
  left?: boolean;
  className?: string;
  height?: string;
  disabled?: boolean;
  white?: boolean;
}

const getIcon = (
  left: boolean,
  white: boolean,
  disabled: boolean
): IconType => {
  if (left) {
    if (white) return chevronLeftWhite;
    if (disabled) return chevronLeftLg;
    return chevronLeftDG;
  }
  if (white) return chevronRightWhite;
  if (disabled) return chevronRightLg;
  return chevronRightDG;
};

const Arrow: FC<ArrowProps> = ({
  onClick,
  left = false,
  white = false,
  className,
  height = '32',
  disabled = false
}) => (
  <Picture
    pictureClassName={className ?? ''}
    height={height}
    onClick={disabled ? undefined : onClick}
    iconHover={
      left
        ? disabled
          ? chevronLeftLg
          : chevronLeftRed
        : disabled
        ? chevronRightLg
        : chevronRightRed
    }
    icon={getIcon(left, white ?? false, disabled)}
  />
);

export default Arrow;
